export const extractYearFromLabel = (label?: string, fallbackYear: number = new Date().getFullYear()): number => {
    return label ? Number(label.match(/\d+/)?.[0] || fallbackYear) : fallbackYear;
};

export const calculatePercentageDifference = (currentValue: number, baseValue: number): number => {
    return ((currentValue - baseValue) / Math.abs(baseValue)) * 100;
};
